import { OEPanelGammaLeg } from "./oe-panel-gamma-leg.model";

export class GammaLegCcyPairTuple {
  public leg: OEPanelGammaLeg;
  public ccyPair: any;
}
